import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormModule, InputModule, ParagraphModule, SelectModule } from '@valtimo/components';
import { PluginTranslatePipeModule } from '@valtimo/plugin';
import { ExecuteActionConfigurationComponent } from './components/execute-action/execute-action-configuration.component';
import { TezzaConfigurationComponent } from './components/tezza-configuration/tezza-configuration.component';

@NgModule({
    declarations: [
        TezzaConfigurationComponent,
        ExecuteActionConfigurationComponent
    ],
    imports: [
        CommonModule,
        PluginTranslatePipeModule,
        FormModule,
        InputModule,
        SelectModule,
        ParagraphModule,
    ],
    exports: [
        TezzaConfigurationComponent,
        ExecuteActionConfigurationComponent
    ],
})
export class TezzaModule { }